import { render, staticRenderFns } from "./commercialTenant.vue?vue&type=template&id=b5905442&"
import script from "./commercialTenant.vue?vue&type=script&lang=ts&"
export * from "./commercialTenant.vue?vue&type=script&lang=ts&"
import style0 from "./commercialTenant.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports